import axios from '../../axios'

export const apiFetchMethodsMixin = {
  data() {
    return {
      fetchedGroupMembers: [],
      fetchedUsersData: [],

      fetchedProjectApplicationData: [],
      fetchedProjectsData: [],

      fetchedStatusReportData: [],
      fetchedStatusReportIdentifiedRisksData: [],

      fetchedPeerReviewRounds: []
    }
  },

  methods: {
    /*user related API fetch methods*/

    async fetchUsers() {
      const config = {
        params: {
          groups: [3]
        }
      }

      const response = await axios.get('users', config)
      this.fetchedUsersData = response.data
    },

    async fetchGroupMembers() {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }

      const response = await axios.get('user-project-attributions', params)
      this.fetchedGroupMembers = response.data
    },

    /*project related API fetch methods*/

    async fetchProjectApplicationData() {
      const config = {
        params: {
          student: this.getUserId
        }
      }

      const response = await axios.get('project-applications', config)
      this.fetchedProjectApplicationData = response.data
    },

    async fetchActiveCCPProjects() {
      const config = {
        params: {
          module: 1,
          is_archived: false
        }
      }

      const response = await axios.get('projects', config)
      this.fetchedProjectsData = response.data
    },

    /*status report related API fetch methods*/

    async fetchStatusReportData() {
      const responseProjectId = await this.getProjectId

      const config = {
        params: {
          project_id: responseProjectId
        }
      }

      const response = await axios.get('status-reports', config)

      this.fetchedStatusReportData = response.data.map((item) => ({
        ...item,
        weekNumber: this.getWeekNumber(new Date(item.creation_date))
      }))
    },

    async fetchStatusReportRisks() {
      const config = {
        params: {
          report_id: this.statusReportId
        }
      }

      const response = await axios.get('status-report-identified-risks', config)
      this.fetchedStatusReportIdentifiedRisksData = response.data
    },

    /*role related API fetch methods*/

    async fetchRoles() {
      const response = await axios.get('user-roles')
      this.roles = response.data
    },

    async fetchPeerReviewRounds() {
      const response = await axios.get('peer-review-rounds')
      this.fetchedPeerReviewRounds = response.data
    }
  }
}
